import { Button } from '@progress/kendo-react-buttons';
import { FallbackProps } from 'react-error-boundary';
import styles from './ErrorPage.module.scss';

export default function ErrorPage(props: FallbackProps) {
    const { error, resetErrorBoundary } = props;
    const splitStack = (error: Error) => (error?.stack ?? '').split('\n').filter((l, idx) => idx !== 0);

    const renderStack = (error: Error) => splitStack(error).map((line) => (
        <p key={line} className={styles.stackLine}>{line}</p>
    ));

    return (
        <div className={styles.container}>
            <div>
                <h3 className={styles.header}>Unexpected Error Occured</h3>
            </div>
            <div>
                <h4 className={styles.info}>
                    {`Message: ${error.message ?? ''}`}
                </h4>
                <div className={styles.stack}>
                    <h5>Stack Trace</h5>
                    {renderStack(error)}
                </div>
            </div>
            <div>
                <Button className={styles.button} onClick={resetErrorBoundary}>
                    Try Again
                </Button>
            </div>
        </div>
    );
}